import { Button } from "../../../../core/components/atoms/Button";
import { Typography } from "../../../../core/components/molecules/Typography";
import { Modal } from "../../../../core/components/templates/Modal";

interface ICorrectionInfoModal {
  isOpen: boolean;
  onClose: () => void;
}

const CorrectionInfoModal: React.FC<ICorrectionInfoModal> = ({ isOpen, onClose }) => {
  const zendeskURL = "https://aprovatotal.zendesk.com/hc/pt-br/articles/18871376469773--Controle-de-qualidade-de-corre%C3%A7%C3%B5es-como-%C3%A9-feito";

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose()}
      position="center"
      className="p-0 w-[400px]"
    >
      <div className="flex flex-col gap-lg">
        <Typography weight="bold" className="mb-8">
          Controle de qualidade de correções
        </Typography>
        <Typography>          
          No Aprova Total, <b>as correções de redação são realizadas por uma equipe de corretores especializados, 
          garantindo que o processo seja humano e não automatizado por inteligência artificial</b>. Após o envio da 
          redação pela plataforma, os corretores avaliam o texto e, em seguida, o aluno pode dar uma nota de 1 a 5 
          estrelas para a correção recebida. <b>Se o aluno identificar algum erro ou discordar da avaliação, ele pode 
          deixar um feedback negativo {"("}1 a 3 estrelas{")"} e solicitar uma recorreção</b>, onde os monitores revisam a 
          correção, fornecem explicações e ajustam a nota, se necessário.
        </Typography>
        <Typography className="mb-8">
          Além disso, <b>há um sistema de moderação e auditoria que revisa certas correções antes de serem enviadas 
          ao aluno</b>, especialmente em casos como textos ilegíveis, fuga ao tema ou atribuição de notas extremas. 
          Essas correções passam por uma revisão adicional da Equipe Pedagógica para <b>garantir que o feedback seja 
          justo e preciso</b>. Esse processo de dupla verificação ajuda a manter a alta qualidade das correções, 
          garantindo que os alunos recebam o suporte necessário para aprimorar suas habilidades de escrita.
        </Typography>
        <Typography> 
          Para <b>mais informações</b> sobre o processo de correção e controle de qualidade, 
          acesse o link: <a href={zendeskURL} target="__blank"> {zendeskURL} </a>
        </Typography>
        <div className="flex flex-row items-center justify-end gap-sm">
          <Button variant="text" onClick={() => onClose()}>
            Ok!
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default CorrectionInfoModal;